import { CLIENT_ID } from "@/utils/clientId";
import Axios, { type AxiosRequestConfig, type AxiosError } from "axios";
import Qs from "qs";

export const serializeInternalApiParams = (
  params: Record<string, unknown>
): string => {
  return Qs.stringify(params, {
    arrayFormat: "brackets",
    encodeValuesOnly: true,
  });
};

export const AXIOS_INSTANCE = Axios.create({
  baseURL: `${window.location.protocol}//${window.location.host}/api/internal/v1`,
  withCredentials: true,
  paramsSerializer: serializeInternalApiParams,
});

// Cancellation rides on `config.signal`: Orval forwards the AbortSignal that
// Vue Query hands its `queryFn` into every generated call, and axios aborts the
// request when it fires. This used to also attach a `CancelToken` plus a
// `promise.cancel` hook — that hook was Vue Query v3's cancellation protocol,
// and v5 does not use it (query-core cancels through the signal alone, see
// `abortSignalConsumed` in its `Query`), so nothing ever called it. `CancelToken`
// has been deprecated since axios 0.22 and is slated for removal.
export const axiosClient = <T>(config: AxiosRequestConfig): Promise<T> => {
  const headers = {
    ...config.headers,
    Accept: "application/json",
    "Content-Type": "application/json",
    // Lets a broadcast triggered by this call be recognised as our own echo.
    "X-Client-Id": CLIENT_ID,
  };

  return AXIOS_INSTANCE({ ...config, headers }).then(({ data }) => data);
};

export default axiosClient;

export type ErrorType<Error> = AxiosError<Error>;
